import React from 'react'

import {
  arrayOf,
  shape,
  string,
  object,
  func,
} from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

const renderCell = (row, key, customRender) => {
  const value = row[key]
  if (customRender) return customRender(value, row)

  if (value && typeof value === 'object') {
    return value.text || value.name || value.label || ''
  }

  return String(value ?? '')
}

function TableBody({ columns = EMPTY_ARRAY, rows = EMPTY_ARRAY, renderCustomCell = null }) {
  if (!columns.length || !rows.length) return null

  return (
    <tbody>
      {rows.map((row, rowIndex) => (
        <tr key={`row-${rowIndex}`}>
          {columns.map(({ key }) => (
            <td key={`${rowIndex}-${key}`}>
              {renderCell(row, key, renderCustomCell?.[key])}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  )
}

TableBody.propTypes = {
  columns: arrayOf(
    shape({
      key: string.isRequired,
    })
  ).isRequired,
  rows: arrayOf(object).isRequired,
  renderCustomCell: shape({
    [string]: func,
  }),
}

export default TableBody
